import React, { useEffect, useMemo, useState } from "react";

import AppNotificationSettings from "./AppNotificationSettings";
import GeneralNotificationSettings from "./GeneralNotificationSettings";
import Card from "../../../../../common/components/Card/Card";
import Heading from "../../../../../common/components/Heading/Heading";
import { useModal } from "../../../../../common/components/Modal/Modal";
import { getActiveApps } from "../../../../../common/util/appsUtil";
import identifiers from "../../../../../common/util/identifiers.json";
import { useAppContext } from "../../../../context/App/App.context";

export default function NotifyMeAboutCard() {
  const {
    Modal: NotifyMeAboutModal,
    toggle,
    modalProps,
  } = useModal({
    size: "narrow",
  });
  const { apps } = useAppContext();
  const activeApps = useMemo(() => getActiveApps(apps), [apps]);

  const [selectedAppsNumber, setSelectedAppsNumber] = useState<number>(0);

  useEffect(() => {
    const count = activeApps.filter((app) => app.follow_app).length;
    setSelectedAppsNumber(count);
  }, [setSelectedAppsNumber, activeApps]);

  return (
    <>
      <Card>
        <Heading
          as="h3"
          heading3
          marginBottom={24}
          testId={identifiers["notifications.notify.header"]}
        >
          Notify me about
        </Heading>

        <GeneralNotificationSettings
          toggleModal={toggle}
          selectedAppsNumber={selectedAppsNumber}
        />
      </Card>

      <AppNotificationSettings
        toggleModal={toggle}
        setSelectedAppsNumber={setSelectedAppsNumber}
        Modal={NotifyMeAboutModal}
        internalProps={modalProps}
      />
    </>
  );
}
